import { Button } from "@mui/material";

import AlertConfirm from "commons/ui/alert/AlertConfirm";
import DataTableSimple from "commons/ui/datatable/DataTableSimple";
import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import Paper from "commons/ui/Paper";

import PagesTableFilters from "components/subComponents/PagesTableFilters";

import usePagesList from "hooks/list/usePagesList";

function ElencoPagine() {
    const pagesListHook = usePagesList();

    const { navigateToNewPage, dataTableHook, alertConfirmHook } = pagesListHook;

    return (
        <GridColumn>
            <AlertConfirm alertConfirmHook={alertConfirmHook} />

            <Paper className={"table-with-filters"}>
                <PagesTableFilters pagesListHook={pagesListHook} />

                <DataTableSimple dataTableHook={dataTableHook} />
            </Paper>

            <GridRow justifyContent={"right"}>
                <GridItem className={"button-under-paper"}>
                    <Button variant={"contained"} onClick={navigateToNewPage}>
                        Nuova Pagina
                    </Button>
                </GridItem>
            </GridRow>
        </GridColumn>
    );
}

export default ElencoPagine;
